import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Hidden,
  LinearProgress,
  Radio,
  Stack,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Formik, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import { useSnackbar } from 'notistack';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { MFCheckbox } from '../../lib/formik/Checkbox';
import UseRadioGroup from '../../lib/formik/Radio';
import MFTextField from '../../lib/formik/TextField';
import { updateApplication } from '../../redux-store/actions/application';
import { showError } from '../../redux-store/actions/auth';
import {
  getStarategyListOfDirect,
  getStrategies,
  getFeeSlabOptimizedListOfDirect,
} from '../../redux-store/actions/strategies';
import { RootStateType } from '../../redux-store/reducers';
import {
  ApplicationProps,
  FeeSlabsType,
  FeeType,
  StrategyDetailsType,
  StrategyType,
} from '../../redux-store/types/api-types';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  FundInvestStockMarket,
  Liquid_FeeType,
  ModeOfTransaction,
  stpApplicableOptions,
  USER_ROLES,
} from '../../utils/constant';
import { StrategyDetailSchema, strategyDeclarationScheme } from '../../utils/schema';
import {
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  checkInitialApplicationStatusIsChecker,
  checkStrategyBoxSelected,
  checkStrategyFeeSlabSelected,
  checkStrategyFeeTypeSelected,
  containsLiquid,
  currencyConversion,
  getDisableStatusForjointHolder,
  getTotalStrategyAmount,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
  checkValidationBasedOnDate,
  containsEquity,
  checkIfApplicationIsNonIndividual,
  isLumpSumMode,
  isNumericTo,
  getRangeLabel,
} from '../../utils/utilityFunctions';
import { DataTable } from '../DataTable';
import { InfoDialog, Notes, ProceedSaveLater, SubHeading } from './components';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import { Distributor, getCurrentDate } from '../../redux-store/actions';
import { getDistributorById } from '../../redux-store/actions/userManagement';
import { numberRegex, numberRegexWithDigit } from '../../utils/regex';
import { ConfirmationDialog } from '../commonComponents';
import LiquidAndEquityStrategyDetails, {
  getAvailableStartDates,
} from './strategyComponents/equityStrategyDetails';
import { useValidationOrConfigHook } from '../../utils/validationOrConfigHook';
import moment from 'moment-timezone';

export type Frequency = 'Monthly' | 'Quarterly' | 'Fortnightly' | 'Weekly';
export type updatedFeeSlabDetails = FeeSlabsType;
export type updatedStrategyDetails = StrategyDetailsType & {
  maxFee: number | null;
  minFee: number | null;
  performanceMaxFee: number | null;
  performanceMinFee: number | null;
  exitMaxFee: number | null;
  exitMinFee: number | null;
  feeType: FeeType;
};

export type StpApplicableData = {
  trancheAmount: number | null;
  numberOfInstallments: number | null;
  frequencyOfInstallments: string | null;
  installmentStartDate: string | null;
  installmentEndDate: string | null;
  availableStartDates?: string[] | null;
};

export type Values = {
  applicationstrategydetails: Partial<updatedStrategyDetails>[];
  investmentAmount: string | number | null;
  totalLumpsumInvestmentAmount: string | number | null;
  feeSlabdetails: Partial<updatedFeeSlabDetails>[];
  liquidFeeSlabDetails: Partial<updatedFeeSlabDetails>[];
  cheque: boolean;
  rtgs: boolean;
  saveType: string;
  isSTPApplicable: boolean;
  currentDate?: Date | null;
  stpApplicableData: StpApplicableData;
};

const isLiquidFreeSlab = (val: FeeSlabsType[]): FeeSlabsType[] => {
  return val.filter((item) => item.feeType === Liquid_FeeType);
};
export const isEquityFreeSlab = (val: FeeSlabsType[]): FeeSlabsType[] => {
  return val.filter((item) => item.feeType !== Liquid_FeeType);
};

export const newStrategy: Partial<updatedStrategyDetails> = {
  strategyName: '',
  strategyType: '',
  strategyId: '',
  fee: null,
  strategyFees: null,
  performanceFee: null,
  exitFee: null,
  performanceFeeNature: '',
  managementFeeNature: '',
  investmentAmount: null,
  installmentAmount: null,
  trancheAmount: null,
  isActive: false,
  maxFee: null,
  minFee: null,
  performanceMaxFee: null,
  performanceMinFee: null,
  exitMaxFee: null,
  exitMinFee: null,
  feeType: '',
  lumpsumInvestmentAmount: null,
  includeLumspsum: '',
  investmentMode: '',
  sno: null,
};

const initialValues: Values = {
  applicationstrategydetails: [],
  feeSlabdetails: [],
  liquidFeeSlabDetails: [],
  investmentAmount: null,
  totalLumpsumInvestmentAmount: null,
  cheque: false,
  rtgs: false,
  saveType: 'save and proceed',
  isSTPApplicable: false,
  currentDate: null,
  stpApplicableData: {
    frequencyOfInstallments: '',
    installmentEndDate: null,
    installmentStartDate: null,
    numberOfInstallments: null,
    trancheAmount: null,
  },
};

const styles: any = {
  header: {
    my: 0,
    py: 0,
    border: 0,
    minWidth: 90,
  },
  tableCellBorder: { my: 0, border: 0, py: 0 },
  boxTitle: {
    fontSize: { xs: 11, md: 14 },
    fontWeight: 400,
    color: '#2057A6',
    textAlign: 'left',
    px: { xs: 0.5, md: 1.5 },
    py: { xs: 0.5, md: 1 },
    height: 48,
    display: 'flex',
    alignItems: 'center',
    background: '#EBF2FA',
  },
  boxValues: {
    py: { xs: 0.5, md: 1 },
    px: { xs: 0.5, md: 1.5 },
    background: '#fafafb',
  },
  boxValuesText: {
    fontSize: { xs: 14, md: 16 },
    fontWeight: 400,
    color: '#293139',
    mb: 0.5,
  },
};

const FeeSlabBox = memo(
  ({
    values,
    setValues,
    feeSlabs,
    isLiquid,
  }: {
    values: Values;
    setValues: FormikHelpers<Values>['setValues'];
    feeSlabs: Partial<updatedFeeSlabDetails>[];
    isLiquid: boolean;
  }): JSX.Element => {
    return (
      <>
        {feeSlabs?.map((fee, slabIndex) => (
          <Box
            key={slabIndex}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              border: '1px solid #CBCBCB',
              borderRadius: '2px',
              mb: 1,
            }}>
            {isLiquid ? (
              <MFCheckbox
                name={`liquidFeeSlabDetails.${slabIndex}.isActive`}
                label={''}
                icon={<RadioButtonUnchecked />}
                checkedIcon={<RadioButtonChecked />}
                size={'small'}
                sx={{ minWidth: 'unset', py: 2, px: { xs: 0, md: 1 }, m: 0 }}
                onChange={({ target: { value } }) => {
                  setValues({
                    ...values,
                    liquidFeeSlabDetails: values.liquidFeeSlabDetails.map((fee, ind) => {
                      const Checked = ind === slabIndex;
                      return {
                        ...fee,
                        isActive: Checked,
                      };
                    }),
                  });
                }}
              />
            ) : (
              <MFCheckbox
                name={`feeSlabdetails.${slabIndex}.isActive`}
                label={''}
                icon={<RadioButtonUnchecked />}
                checkedIcon={<RadioButtonChecked />}
                size={'small'}
                sx={{ minWidth: 'unset', py: 2, px: { xs: 0, md: 1 }, m: 0 }}
                onChange={({ target: { value } }) => {
                  setValues({
                    ...values,
                    feeSlabdetails: values.feeSlabdetails.map((fee, ind) => {
                      const Checked = ind === slabIndex;
                      return {
                        ...fee,
                        isActive: Checked,
                      };
                    }),
                  });
                }}
              />
            )}

            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                flexGrow: 1,
                flexWrap: 'wrap',
                background: '#fafafb',
              }}>
              <Box sx={{ width: { xs: '50%', lg: '25%' } }}>
                <Typography sx={styles.boxTitle}>Management Fees %</Typography>
                <Box sx={styles.boxValues}>
                  <Typography sx={styles.boxValuesText}>{fee.mgmtFee}</Typography>
                </Box>
              </Box>
              <Box sx={{ width: { xs: '50%', lg: '25%' } }}>
                <Typography sx={styles.boxTitle}>Operating Expenses %</Typography>
                <Box sx={styles.boxValues}>
                  <Typography sx={styles.boxValuesText}>{fee.optFee}</Typography>
                </Box>
              </Box>
              <Box sx={{ width: { xs: '100%', lg: '50%' }, background: '#EBF2FA' }}>
                <Typography
                  sx={{
                    ...styles.boxTitle,
                    height: 24,
                    py: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                  }}>
                  Exit Load %
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  {fee.exitload?.map((exit, i) => (
                    <Box key={i} sx={{ width: '25%' }}>
                      <Typography
                        sx={{
                          ...styles.boxTitle,
                          fontsize: 12,
                          fontWeight: 600,
                          height: 24,
                          py: 0.2,
                        }}>
                        {exit.frequency}
                      </Typography>
                      <Box sx={styles.boxValues}>
                        <Typography sx={styles.boxValuesText}>{exit.exitload}</Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
              {fee?.hurdlerates && fee?.hurdlerates?.length > 0 && (
                <>
                  <Box sx={{ width: '50%' }}>
                    <Typography sx={styles.boxTitle}>Profit sharing % above hurdle rate</Typography>
                    <Box sx={styles.boxValues}>
                      {fee.hurdlerates?.length ? (
                        fee.hurdlerates?.map((rate, rateIndex) => (
                          <Typography key={rateIndex} sx={styles.boxValuesText}>
                            {rate.profit}
                          </Typography>
                        ))
                      ) : (
                        <Typography sx={styles.boxValuesText}>-</Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ width: '50%', background: '#EBF2FA' }}>
                    <Typography sx={{ ...styles.boxTitle, height: 24, py: 0.2 }}>
                      Profit Hurdle Rate
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                      <Box sx={{ width: '50%' }}>
                        <Typography
                          sx={{
                            ...styles.boxTitle,
                            fontsize: 12,
                            fontWeight: 600,
                            height: 24,
                            py: 0.2,
                          }}>
                          % from
                        </Typography>
                        <Box sx={styles.boxValues}>
                          {fee.hurdlerates?.length ? (
                            fee.hurdlerates?.map((rate, rateIndex) => (
                              <Typography key={rateIndex} sx={styles.boxValuesText}>
                                {isNumericTo(rate?.to, numberRegexWithDigit)
                                  ? rate.from
                                  : getRangeLabel(rate)}
                              </Typography>
                            ))
                          ) : (
                            <Typography sx={styles.boxValuesText}>-</Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ width: '50%' }}>
                        <Typography
                          sx={{
                            ...styles.boxTitle,
                            fontsize: 12,
                            fontWeight: 600,
                            height: 24,
                            py: 0.2,
                          }}>
                          % to
                        </Typography>
                        <Box sx={styles.boxValues}>
                          {fee.hurdlerates?.length ? (
                            fee.hurdlerates?.map((rate, rateIndex) => (
                              <Typography
                                key={rateIndex}
                                sx={{
                                  ...styles.boxValuesText,
                                  opacity: isNumericTo(rate?.to, numberRegexWithDigit) ? 1 : 0,
                                }}>
                                {isNumericTo(rate?.to, numberRegexWithDigit)
                                  ? rate.to
                                  : getRangeLabel(rate)}
                              </Typography>
                            ))
                          ) : (
                            <Typography sx={styles.boxValuesText}>-</Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        ))}
      </>
    );
  }
);

FeeSlabBox.displayName = 'FeeSlabBox';

function FeeSlabTable({
  _index,
  values,
  setValues,
  feeSlabs,
}: {
  _index: number;
  values: Values;
  setValues: FormikHelpers<Values>['setValues'];
  feeSlabs: Partial<updatedFeeSlabDetails>[];
}): JSX.Element {
  const headers = [
    {
      header: 'Fee Name',
      label: 'feeName',
      renderEditDeleteCell: (
        params: Partial<updatedFeeSlabDetails>,
        index: number
      ): JSX.Element => {
        return (
          <>
            <MFCheckbox
              name={`feeSlabdetails.${index}.isActive`}
              label={params.feeName || ''}
              icon={<RadioButtonUnchecked />}
              checkedIcon={<RadioButtonChecked />}
              size={'small'}
              sx={{ minWidth: '200px' }}
              onChange={({ target: { value } }) => {
                setValues({
                  ...values,
                  feeSlabdetails: values.feeSlabdetails.map((fee, ind) => {
                    const Checked = ind === index;
                    return {
                      ...fee,
                      isActive: Checked,
                    };
                  }),
                });
              }}
            />
          </>
        );
      },
    },
    {
      header: 'Management Fees',
      label: 'mgmtFee',
      renderEditDeleteCell: (params: updatedFeeSlabDetails) => {
        return <Typography>{params.mgmtFee}</Typography>;
      },
    },
    {
      header: 'Operating Expenses',
      label: 'optFee',
      renderEditDeleteCell: (params: updatedFeeSlabDetails) => {
        return <Typography>{params.optFee}</Typography>;
      },
    },
    {
      header: () => {
        return (
          <>
            <Hidden only="xs">
              <TableHead sx={{ my: 0, py: 0 }}>
                <TableCell
                  align="center"
                  sx={{
                    ...styles.tableCellBorder,
                    minWidth: 200,
                    pl: '16px !important',
                  }}>
                  Profit sharing % above hurdle rate
                </TableCell>
                <TableCell align="center" sx={styles.tableCellBorder}>
                  <TableRow>
                    <TableCell align="center" colSpan={2} sx={styles.tableCellBorder}>
                      <Typography sx={{ textAlign: 'center' }}>Profit Hurdle Rate</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={styles.header}>% from</TableCell>
                    <TableCell sx={{ ...styles.header, pr: 0 }}>% to</TableCell>
                  </TableRow>
                </TableCell>
              </TableHead>
            </Hidden>
            <Hidden smUp={true}>
              <Typography variant="h6">Hurdle Rate</Typography>
            </Hidden>
          </>
        );
      },
      label: 'hurdlerates',
      isDisplay: ['Hybrid', 'Variable', ''].includes(
        values?.applicationstrategydetails[_index]?.feeType || ''
      ),
      isVisibleInMobileView: (params: updatedFeeSlabDetails) => !!params.hurdlerates?.length,
      renderEditDeleteCell: (params: updatedFeeSlabDetails) => {
        return (
          <>
            <Hidden only="xs">
              {!params.hurdlerates?.length ? (
                <TableRow sx={styles.header}>
                  <TableCell align="center" sx={{ ...styles.header, minWidth: 200 }}>
                    -
                  </TableCell>
                  <TableCell sx={styles.header}>
                    <TableRow>
                      <TableCell align="center" sx={{ ...styles.header, pl: 0 }}>
                        -
                      </TableCell>
                      <TableCell align="center" sx={styles.header}>
                        -
                      </TableCell>
                    </TableRow>
                  </TableCell>
                </TableRow>
              ) : (
                params.hurdlerates?.map((rate, i) => {
                  return (
                    <TableRow sx={styles.header} key={i}>
                      <TableCell align="center" sx={{ ...styles.header, minWidth: 200 }}>
                        {rate.profit}
                      </TableCell>
                      {rate.from && isNumericTo(rate?.to, numberRegex) ? (
                        <TableCell sx={styles.header}>
                          <TableRow>
                            <TableCell align="center" sx={{ ...styles.header, pl: 0 }}>
                              {rate.from}
                            </TableCell>
                            <TableCell align="center" sx={styles.header}>
                              {rate.to}
                            </TableCell>
                          </TableRow>
                        </TableCell>
                      ) : (
                        <TableCell colSpan={2} sx={styles.header}>
                          {getRangeLabel(rate)}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })
              )}
            </Hidden>
            <Hidden smUp={true}>
              {params.hurdlerates?.map((rate) => {
                return (
                  <>
                    <Grid item>
                      <Typography variant="h6">Profit sharing % above hurdle rate</Typography>
                      <Typography>{rate.profit}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="h6">Profit Hurdle Rate</Typography>
                      {rate.from && isNumericTo(rate?.to, numberRegex) ? (
                        <>
                          <Grid item>
                            <Typography variant="h6">% from</Typography>
                            <Typography>{rate.from}</Typography>
                          </Grid>
                          <Grid item>
                            <Typography variant="h6">% to</Typography>
                            <Typography>{rate.to}</Typography>
                          </Grid>
                        </>
                      ) : (
                        <Grid item>
                          <Typography>{getRangeLabel(rate)}</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </>
                );
              })}
            </Hidden>
          </>
        );
      },
    },
    {
      header: () => {
        return (
          <>
            <Hidden only="xs">
              <TableHead sx={{ my: 0, py: 0 }}>
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={4}
                    sx={{
                      my: 0,
                      border: 0,
                      py: 0,
                    }}>
                    <Typography sx={{ textAlign: 'center' }}>Exit Load with in days</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={styles.header}>0 to 365</TableCell>
                  <TableCell sx={styles.header}>366 to 730</TableCell>
                  <TableCell sx={styles.header}>731 to 1095</TableCell>
                  <TableCell sx={styles.header}>1095 & more</TableCell>
                </TableRow>
              </TableHead>
            </Hidden>
            <Hidden smUp={true}>
              <Typography variant="h6">Exit Load with in days</Typography>
            </Hidden>
          </>
        );
      },
      label: 'exitFee',
      renderEditDeleteCell: (params: updatedFeeSlabDetails) => {
        return (
          <>
            <Hidden only="xs">
              <TableCell sx={styles.header}>
                {params.exitload?.map((exit, i) => {
                  return (
                    <TableCell key={i} align="center" sx={styles.header}>
                      {exit.exitload}
                    </TableCell>
                  );
                })}
              </TableCell>
            </Hidden>
            <Hidden smUp={true}>
              <Box minWidth={90}>
                {params.exitload?.map((exit, i) => {
                  return (
                    <>
                      <Typography variant="h6">{`${exit.frequency}`}</Typography>
                      <Typography>{exit.exitload}</Typography>
                    </>
                  );
                })}
              </Box>
            </Hidden>
          </>
        );
      },
    },
    {
      header: '',
      label: 'end',
      renderCell: (params: updatedFeeSlabDetails) => {
        return <>{params.end}</>;
      },
    },
  ];

  return (
    <DataTable
      tableData={feeSlabs || []}
      tableHeader={
        headers
          .filter((header) => header.isDisplay !== false)
          .map((header) => {
            const { isDisplay, ...rest } = header;
            return rest;
          }) || []
      }
      renderAdditionalRow={false}
      tableHeaderCustomStyles={{
        '.MuiTableCell-head': {
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          fontWeight: 500,
          color: 'primary.main',
          textAlign: 'left',
          pl: 2,
          '&:nth-of-type(1)': {
            pl: 6,
          },
          '&:nth-of-type(3)': {
            pr: 0,
          },
          '&:nth-of-type(4)': {
            pl: 0,
          },
          '& .MuiTableRow-root': {
            '.MuiTableCell-head': {
              pl: 0,
              '&:nth-of-type(3)': {
                pr: 2,
              },
            },
          },
        },
      }}
      rowCustomStyles={{
        '.MuiTableCell-root': {
          fontSize: '1rem',
          lineHeight: 1.5,
          py: 0,
          overflowWrap: 'anywhere',
          textAlign: 'left',
          verticalAlign: 'middle',
          '&:nth-of-type(3)': {
            pr: 0,
          },
          '&:nth-of-type(4)': {
            pl: 0,
          },
          '& .MuiTableRow-root': {
            '.MuiTableCell-head': {
              '&:nth-of-type(1)': {
                pl: 0,
              },
            },
          },
        },
      }}
      boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
    />
  );
}

const FeeTypeComponent = memo(
  ({
    feeSlabsData,
    strategy,
    applicationStrategyIndex,
    values,
    setValues,
  }: {
    feeSlabsData: FeeSlabsType[];
    strategy: Partial<updatedStrategyDetails>;
    applicationStrategyIndex: number;
    values: Values;
    setValues: FormikHelpers<Values>['setValues'];
  }): JSX.Element => {
    const isLiquidStrategy = containsLiquid(strategy?.strategyName || '');
    const liquidFeeSlab = isLiquidFreeSlab(feeSlabsData);
    const equityFeeSlab = isEquityFreeSlab(feeSlabsData);
    const FeeTypeMaster = feeSlabsData
      .map((fee) => fee.feeType)
      .filter((val) => val !== Liquid_FeeType)
      .filter((value, index, array) => array.indexOf(value) === index);

    const liquidFeesTypeMaster = feeSlabsData
      .map((fee) => fee.feeType)
      .filter((val) => val === Liquid_FeeType)
      .filter((value, index, array) => array.indexOf(value) === index);

    const handleFeeTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      const updatedStrategies = values.applicationstrategydetails.map((strategy) => {
        if (containsLiquid(strategy.strategyName || '') && strategy.isActive) {
          return {
            ...strategy,
            feeType: Liquid_FeeType as FeeType,
          };
        } else if (strategy.isActive) {
          return {
            ...strategy,
            feeType: value as FeeType,
          };
        } else {
          return strategy;
        }
      });

      setValues({
        ...values,
        applicationstrategydetails: updatedStrategies,
        feeSlabdetails: isLiquidStrategy
          ? values.feeSlabdetails
          : equityFeeSlab.filter((fee) => fee.feeType === (value as FeeType)),
        liquidFeeSlabDetails:
          values.liquidFeeSlabDetails.length > 0 ? values.liquidFeeSlabDetails : liquidFeeSlab,
      });
    };

    return (
      <>
        <Grid container>
          {values.isSTPApplicable && <SubHeading>Fee type for Equity Strategy</SubHeading>}
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              '& .MuiFormControl-root': {
                mb: 3,
                height: 'auto',
                '& .MuiFormControlLabel-root': { mb: { xs: 1, sm: 0 } },
              },
            }}>
            <UseRadioGroup
              key={`fee-type-${applicationStrategyIndex}-${values.applicationstrategydetails[applicationStrategyIndex].feeType}`}
              formLabel="Fee Type *"
              name={`applicationstrategydetails.${applicationStrategyIndex}.feeType`}
              items={(isLiquidStrategy ? liquidFeesTypeMaster : FeeTypeMaster).map((fee) => ({
                label: fee,
                value: fee,
              }))}
              value={values?.applicationstrategydetails[applicationStrategyIndex]?.feeType}
              onChange={handleFeeTypeChange}
            />
          </Grid>
        </Grid>
        <Box sx={{ borderTop: '1px solid #CBCBCB', pt: 2 }}>
          <FeeSlabBox
            setValues={setValues}
            values={values}
            feeSlabs={isLiquidStrategy ? values.liquidFeeSlabDetails : values.feeSlabdetails}
            isLiquid={isLiquidStrategy}
          />
        </Box>
      </>
    );
  }
);

FeeTypeComponent.displayName = 'FeeTypeComponent';

const StrategyAccordionAndFeeSlabsTable = memo(
  ({
    values,
    setValues,
    feeSlabsData,
    strategyMasterData,
    strategy,
    applicationStrategyIndex,
    setSelectedLiquidStrategy,
    setOpenLiquid,
  }: {
    values: Values;
    setValues: FormikHelpers<Values>['setValues'];
    strategyMasterData: Partial<StrategyType>[];
    feeSlabsData: FeeSlabsType[];
    strategy: Partial<updatedStrategyDetails>;
    applicationStrategyIndex: number;
    setSelectedLiquidStrategy: (val: number | null) => void;
    setOpenLiquid: (val: boolean) => void;
  }): JSX.Element => {
    const dispatch = useDispatch();
    const { application } = useSelector((store: RootStateType) => store.application);
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const isFieldDisabled = [USER_ROLES.INVESTOR].includes(role);
    const isLiquidStrategy = containsLiquid(strategy.strategyName || '');
    const liquidFeeSlab = isLiquidFreeSlab(feeSlabsData);
    const equityFeeSlab = isEquityFreeSlab(feeSlabsData);

    // Initialize local state with form value
    const investmentAmount = `${values.applicationstrategydetails[applicationStrategyIndex].investmentAmount}`;
    const [localAmount, setLocalAmount] = useState(() => investmentAmount?.toString() || '');

    // Define callback for updating form values
    const onInvestmentAmountChange = useCallback(
      (index: number, value: string) => {
        setValues((prev) => {
          const updatedAmount = prev.applicationstrategydetails?.map((strategyDetails, idx) => {
            if (index === idx) {
              return {
                ...strategyDetails,
                investmentAmount: value ? Number(value) : null,
              };
            }
            return strategyDetails;
          });
          return {
            ...prev,
            applicationstrategydetails: updatedAmount,
            investmentAmount: getTotalStrategyAmount(updatedAmount as updatedStrategyDetails[]),
          };
        });
      },
      [setValues]
    );

    // Debounce the update to main form state
    const debouncedUpdateFormValue = useCallback(
      debounce((value: string) => {
        onInvestmentAmountChange(applicationStrategyIndex, value);
      }, 500),
      [applicationStrategyIndex, onInvestmentAmountChange]
    );

    // Handle local input changes
    const handleAmountChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setLocalAmount(newValue); // Update local state immediately
        debouncedUpdateFormValue(newValue); // Debounce update to form state
      },
      [debouncedUpdateFormValue]
    );

    // Sync local state when form values change externally
    useEffect(() => {
      const formValue = investmentAmount;
      setLocalAmount(formValue?.toString() || '');
    }, [investmentAmount]);

    // Memoize the amount in words calculation
    const amountInWords = useMemo(() => {
      if (!strategy?.isActive || !localAmount || localAmount === '0') {
        return '';
      }
      return currencyConversion(Number(localAmount));
    }, [strategy?.isActive, localAmount]);

    return (
      <Accordion
        sx={{
          boxShadow: 'none',
          mb: 3,
          cursor: 'default',
          '&::before': { display: 'none' },
          '& .MuiOutlinedInput-root': { mt: 0 },
          '& .label': { fontSize: 14, fontWeight: 500, color: 'rgba(0,0,0,0.7)', mb: 1 },
        }}
        expanded={strategy?.isActive}
        TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary
          sx={{
            bgcolor: 'rgba(221, 234, 243, 0.2)',
            borderRadius: '5px',
            cursor: 'default',
            '&.Mui-expanded': { minHeight: 'unset', cursor: 'default' },
            '& .MuiAccordionSummary-content': { m: 0, py: 0.7, '&.Mui-expanded': { m: 0 } },
          }}
          aria-controls="panel1a-content"
          id="panel1a-header">
          <Stack>
            <Typography
              sx={{
                color: '#131836',
                fontSize: 16,
                fontWeight: 500,
                width: '100%',
                cursor: 'default',
                display: 'flex',
                alignItems: 'center',
              }}>
              <MFCheckbox
                name={`applicationstrategydetails.${applicationStrategyIndex}.isActive`}
                label=""
                sx={{ letterSpacing: '1px', mr: 0 }}
                onChange={({ target: { checked } }) => {
                  const { applicationstrategydetails } = values;

                  const activeStrategies =
                    applicationstrategydetails?.filter((strategy) => strategy.isActive) || [];
                  const liquideStrategies = activeStrategies.filter((strategy) =>
                    containsLiquid(strategy.strategyName || '')
                  );

                  if (isLiquidStrategy && liquideStrategies.length >= 1 && checked) {
                    setSelectedLiquidStrategy(applicationStrategyIndex);
                    setOpenLiquid(true);
                    return;
                  }

                  if (activeStrategies.length >= 4 && checked) {
                    dispatch(
                      showError(
                        'For the application maximum 4 strategies can be selected, please unselect any to add new strategy'
                      )
                    );
                    return;
                  }

                  const activatedEquityStrategies = activeStrategies.find(
                    (strategy) => !containsLiquid(strategy.strategyName || '')
                  );

                  const equityFeeType = activatedEquityStrategies?.feeType;

                  const updatedStrategy: updatedStrategyDetails[] =
                    applicationstrategydetails?.map((strategy, index) => {
                      if (index === applicationStrategyIndex) {
                        return {
                          ...strategy,
                          isActive: checked,
                          investmentAmount: '',
                          feeType: checked
                            ? containsLiquid(strategy.strategyName || '')
                              ? Liquid_FeeType
                              : checked
                              ? equityFeeType
                              : strategy.feeType
                            : null,
                        } as updatedStrategyDetails;
                      }
                      return strategy as updatedStrategyDetails;
                    }) || [];

                  setValues({
                    ...values,
                    applicationstrategydetails: updatedStrategy,
                    liquidFeeSlabDetails:
                      values.liquidFeeSlabDetails.length > 0 && liquideStrategies.length >= 1
                        ? values.liquidFeeSlabDetails
                        : liquidFeeSlab,
                    feeSlabdetails:
                      activatedEquityStrategies?.strategyId && values.feeSlabdetails.length > 0
                        ? values.feeSlabdetails
                        : equityFeeSlab,
                    investmentAmount: getTotalStrategyAmount(updatedStrategy) || '',
                  });
                }}
                disabled={isFieldDisabled}
              />
              {strategy?.strategyName}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: 'auto',
          }}>
          <FeeTypeComponent
            feeSlabsData={feeSlabsData}
            strategy={strategy}
            applicationStrategyIndex={applicationStrategyIndex}
            setValues={setValues}
            values={values}
          />
          <Box sx={{ maxWidth: 310, '& .MuiFormControl-root': { mb: 0 } }}>
            <MFTextField
              name={`applicationstrategydetails.${applicationStrategyIndex}.investmentAmount`}
              label="Investment Amount *"
              placeholder="Enter Investment Amount"
              type="number"
              onKeyDown={allowOnlyNumbers}
              trimOnBlur={false}
              disabled={isFieldDisabled}
              value={localAmount}
              onChange={handleAmountChange}
            />
            {amountInWords && <Typography sx={{ fontSize: 13 }}>{amountInWords}</Typography>}
          </Box>
        </AccordionDetails>
      </Accordion>
    );
  }
);

StrategyAccordionAndFeeSlabsTable.displayName = 'StrategyAccordionAndFeeSlabsTable';

export default function StrategyDetails(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [isStpLumpsumDateValid, setIsStpLumpsumDateValid] = useState<boolean>(false);
  const [strategyLoader, setStrategyLoader] = useState(false);
  const [strategyData, setStrategyData] = useState<Partial<StrategyType>[]>([]);
  const [stpStrategyData, setSTPStrategyData] = useState<Partial<StrategyType>[]>([]);
  const [feeSlabsData, setFeeSlabsData] = useState<FeeSlabsType[]>([]);
  const [selectedStrategyData, setSelectedStrategyData] = useState(initialValues);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [OpenliquidStrategy, setOpenLiquid] = useState(false);
  const [selectedLiquidStrategy, setSelectedLiquidStrategy] = useState<number | null>(0);
  const [openDialog, setDialog] = useState(false);
  const [stpChange, setSTPChange] = useState<{ open: boolean; stpApplicableValue: boolean }>({
    open: false,
    stpApplicableValue: false,
  });
  const { stpApplicableDate, combineAllStrategyDate } = useValidationOrConfigHook();
  const [initialStrategyResult, setInitialStrategyResult] = useState<
    Partial<StrategyDetailsType>[]
  >([]);

  const setInitialData = (
    responseFeeSlab: FeeSlabsType[],
    result: Partial<StrategyDetailsType>[],
    currentDate: Date | string = ''
  ): Values => {
    const {
      liquidApplicationFeeSlab,
      applicationfeeslab,
      isSTPApplicable,
      investmentAmount,
      frequencyOfInstallments,
      installmentStartDate,
      installmentEndDate,
      trancheAmount,
      numberOfInstallments,
    } = application || {};
    const stpAvailableData: Partial<StpApplicableData> = {
      trancheAmount: trancheAmount,
      numberOfInstallments: numberOfInstallments,
      frequencyOfInstallments: frequencyOfInstallments,
      installmentStartDate: installmentStartDate,
      installmentEndDate: installmentEndDate,
      availableStartDates: getAvailableStartDates(
        currentDate,
        application?.frequencyOfInstallments || ''
      ),
    };

    return {
      ...selectedStrategyData,
      liquidFeeSlabDetails: isLiquidFreeSlab(responseFeeSlab).map((fee) => {
        const { id, ...rest } = fee;

        return {
          ...rest,
          feeSlabId: id,
          isActive: fee.id === liquidApplicationFeeSlab?.feeSlabId,
          hurdlerates: fee.hurdlerates?.length ? fee.hurdlerates : [],
        };
      }),
      feeSlabdetails: isEquityFreeSlab(responseFeeSlab)
        .filter((val1) => val1.feeType === applicationfeeslab?.feeType)
        .map((fee) => {
          const { id, ...rest } = fee;
          return {
            ...rest,
            feeSlabId: id,
            isActive: fee.id === applicationfeeslab?.feeSlabId,
            hurdlerates: fee.hurdlerates?.length ? fee.hurdlerates : [],
          };
        }),

      applicationstrategydetails: result
        ?.map((strategy) => {
          return {
            ...strategy,
            strategyName: strategy.strategyName,
            investmentAmount: strategy.investmentAmount || null,
            isActive: strategy.isActive as boolean,
            feeType: containsLiquid(strategy.strategyName || '')
              ? liquidApplicationFeeSlab?.feeType || null
              : applicationfeeslab?.feeType || null,
            allocation: strategy.allocation,
            installmentAmount: strategy.installmentAmount,
            trancheAmount: containsEquity(strategy || '') ? application?.trancheAmount : null,
          };
        })
        .flat() as Partial<updatedStrategyDetails>[],
      isSTPApplicable: isSTPApplicable as boolean,
      currentDate: currentDate as Date,
      stpApplicableData: stpAvailableData as StpApplicableData,
      investmentAmount: investmentAmount || null,
    };
  };

  useEffect(() => {
    let isComponentAlive = true;

    (async function () {
      setStrategyLoader(true);
      try {
        const isCombinedStrategyDateValid = checkValidationBasedOnDate(
          application?.createdAt || '',
          combineAllStrategyDate
        );

        setIsStpLumpsumDateValid(isCombinedStrategyDateValid);
        const { date: currentDate } = (await dispatch(getCurrentDate())) as unknown as {
          date: Date;
        };
        let response = [] as Partial<StrategyType>[];
        let responseFeeSlab = [] as FeeSlabsType[];
        const { applicationstrategydetails, applicationfeeslab, distributor_id } =
          application || {};
        if (distributor_id) {
          const distributor = (await dispatch(
            getDistributorById(distributor_id)
          )) as unknown as Distributor;
          response = distributor.strategies as Partial<StrategyType>[];
          responseFeeSlab = distributor.feeSlabs as FeeSlabsType[];
        } else {
          response = (await dispatch(
            getStarategyListOfDirect()
          )) as unknown as Partial<StrategyType>[];
          responseFeeSlab = (await dispatch(
            getFeeSlabOptimizedListOfDirect()
          )) as unknown as FeeSlabsType[];
        }
        if (!isComponentAlive) {
          return;
        }

        responseFeeSlab = applicationfeeslab?.feeSlabId
          ? !responseFeeSlab.map((fee) => fee?.id).includes(applicationfeeslab?.feeSlabId)
            ? responseFeeSlab.concat({ ...applicationfeeslab, id: applicationfeeslab?.feeSlabId })
            : responseFeeSlab
          : responseFeeSlab;

        const transformedDataArray: Partial<StrategyType>[] = response.filter((responseData) => {
          return !(applicationstrategydetails || []).some(
            (appData) => appData.strategyId === responseData.id
          );
        });

        const result = [
          ...(applicationstrategydetails || [])?.map((_str, ind) => {
            return { ..._str, sno: ind };
          }),
          ...transformedDataArray.map((val) => {
            const { id, ...rest } = val;
            return {
              ...rest,
              isActive: false,
              strategyId: id,
              trancheAmount: application?.trancheAmount || null,
            };
          }),
        ] as Partial<StrategyDetailsType>[];

        setStrategyData(
          result.map((strategy) => {
            return {
              ...strategy,
              strategyId: strategy?.id,
            };
          })
        );

        setSTPStrategyData(
          result.map((strategy) => {
            return {
              ...strategy,
              trancheAmount: application?.trancheAmount || null,
            };
          })
        );

        setFeeSlabsData(
          responseFeeSlab?.map((fee) => {
            const { id, ...rest } = fee;
            return {
              ...rest,
              isActive: false,
              hurdlerates: fee.hurdlerates?.length ? fee.hurdlerates : [],
              feeSlabId: id,
            };
          })
        );
        setInitialStrategyResult(result);
        const data = setInitialData(responseFeeSlab, result, currentDate);

        setSelectedStrategyData({
          ...data,
          totalLumpsumInvestmentAmount: application?.totalLumpsumInvestmentAmount || null,
        });
        setStrategyLoader(false);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, [application]);
  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();

  const filterActiveSelectedStratagies = (
    isSTPApplicable: boolean,
    applicationStrategyData: Partial<updatedStrategyDetails>[]
  ): Partial<updatedStrategyDetails>[] => {
    return applicationStrategyData
      ?.filter((val) => val.isActive || val.id)
      ?.map((_item) => {
        const { sno, ...rest } = _item;
        return {
          ...rest,
          includeLumspsum: isSTPApplicable ? rest?.includeLumspsum : '',
          investmentMode: isSTPApplicable ? rest?.investmentMode : 'lumpsum',
          lumpsumInvestmentAmount: isSTPApplicable ? rest?.lumpsumInvestmentAmount : null,
        };
      });
  };

  const filterActiveLiquidStrategy = (
    selectedApplicationStrategyData: Partial<updatedStrategyDetails>[]
  ): Partial<updatedStrategyDetails>[] => {
    return selectedApplicationStrategyData?.filter(
      (val) => val.feeType === Liquid_FeeType && (val.isActive || val.id)
    );
  };

  const filterActiveEquityStrategy = (
    selectedApplicationStrategyData: Partial<updatedStrategyDetails>[]
  ): Partial<updatedStrategyDetails>[] => {
    return selectedApplicationStrategyData?.filter(
      (val) => val.feeType !== Liquid_FeeType && (val.isActive || val.id)
    );
  };

  const comparission = (values: Partial<Values>): Partial<ApplicationProps> => {
    const {
      applicationstrategydetails,
      liquidFeeSlabDetails,
      feeSlabdetails,
      isSTPApplicable,
      stpApplicableData,
      rtgs,
      cheque,
      saveType,
      currentDate,
      ...rest
    } = values;
    const {
      trancheAmount,
      frequencyOfInstallments,
      installmentEndDate,
      installmentStartDate,
      numberOfInstallments,
    } = stpApplicableData as StpApplicableData;
    const activeLiquidFeeSlab = (liquidFeeSlabDetails || []).find((fee) => fee.isActive) || {};
    const {
      distributorDetails: liquidDistributorDetails,
      createdBy,
      updatedAt: liquideUpdatedAt,
      updatedBy: liquideUpdatedBy,
      createdAt: liquideCreatedAt,
      ...liquidFeeSlabData
    } = activeLiquidFeeSlab as FeeSlabsType;

    const activeEquityFeeSlab = (feeSlabdetails || []).find((fee) => fee.isActive) || {};
    const {
      distributorDetails: equityDistributorDetails,
      createdBy: equityCreatedBy,
      updatedAt: equityUpdatedAt,
      updatedBy: equityUpdatedBy,
      createdAt: equityCreatedAt,
      ...equityFeeSlabData
    } = activeEquityFeeSlab as FeeSlabsType;
    const prevActiveStrategies = application?.applicationstrategydetails
      .map((_application_Strategy) => {
        const getIds = applicationstrategydetails?.map((_getId) => _getId.id?.toString());
        if (_application_Strategy.id && getIds?.includes(_application_Strategy.id?.toString())) {
          return;
        }
        return _application_Strategy;
      })
      .filter((ele) => ele)
      .filter((val) => val?.isActive || val?.id)
      .filter(
        (str) => !applicationstrategydetails?.some((val) => val.strategyId === str?.strategyId)
      )
      .map((obj) => ({
        ...obj,
        isActive: false,
      }));
    const selectedApplicationstrategydetails = filterActiveSelectedStratagies(
      application?.isSTPApplicable as boolean,
      applicationstrategydetails || []
    );

    const liquidStrategy = filterActiveLiquidStrategy(selectedApplicationstrategydetails);
    const equityStrategy = filterActiveEquityStrategy(selectedApplicationstrategydetails);

    let paymentMode = '';
    if (cheque && rtgs) {
      paymentMode = Object.keys(ModeOfTransaction)?.toString();
    } else if (cheque && !rtgs) {
      paymentMode = 'cheque';
    } else if (!cheque && rtgs) {
      paymentMode = 'rtgs';
    }

    const updatedApplicationstrategydetails = [
      ...(applicationstrategydetails as updatedStrategyDetails[])?.map((_ietm) => {
        const { sno, ...rest } = _ietm;
        return { ...rest };
      }),
      ...(prevActiveStrategies as updatedStrategyDetails[]),
    ]
      .map((str) => {
        const { feeType, ...rest } = str;
        return { ...rest };
      })
      .sort((a, b) => Number(a?.id ?? 0) - Number(b?.id ?? 0));
    const formDataForComparission = {
      ...application,
      ...rest,
      investmentAmount: rest.investmentAmount || null,
      modeOfPayment: paymentMode || null,
      liquidApplicationFeeSlab:
        liquidStrategy.length > 0 && !isSTPApplicable
          ? application?.liquidApplicationFeeSlab?.feeSlabId
            ? {
                id: application?.liquidApplicationFeeSlab?.id,
                ...application?.liquidApplicationFeeSlab,
                ...liquidFeeSlabData,
                hurdlerates:
                  (liquidFeeSlabData?.hurdlerates || [])?.length === 0
                    ? null
                    : liquidFeeSlabData?.hurdlerates,
              }
            : liquidFeeSlabData
          : liquidStrategy.length <= 0 && application?.liquidApplicationFeeSlab?.id
          ? { ...application?.liquidApplicationFeeSlab, isActive: false }
          : null,

      applicationfeeslab:
        equityStrategy.length > 0
          ? application?.applicationfeeslab?.feeSlabId
            ? {
                id: application?.applicationfeeslab?.id,
                ...application?.applicationfeeslab,
                ...equityFeeSlabData,
                hurdlerates:
                  (equityFeeSlabData?.hurdlerates || [])?.length === 0
                    ? null
                    : equityFeeSlabData?.hurdlerates,
              }
            : equityFeeSlabData
          : equityStrategy.length <= 0 && application?.applicationfeeslab?.id
          ? { ...application?.applicationfeeslab, isActive: false }
          : null,

      applicationstrategydetails: isSTPApplicable
        ? (updatedApplicationstrategydetails as StrategyDetailsType[])
        : (selectedApplicationstrategydetails.map((val) => {
            const { feeType, ...restStrategy } = val;
            return { ...restStrategy, investmentAmount: restStrategy.investmentAmount || null };
          }) as updatedStrategyDetails[]),
      trancheAmount: isSTPApplicable ? trancheAmount : null,
      frequencyOfInstallments: isSTPApplicable ? frequencyOfInstallments : null,
      installmentEndDate: isSTPApplicable
        ? moment(installmentEndDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        : null,
      installmentStartDate: isSTPApplicable
        ? moment(installmentStartDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        : null,
      numberOfInstallments: isSTPApplicable ? numberOfInstallments : null,
    };
    return formDataForComparission;
  };

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,

        applicationNumber,
      } = application || {};
      const {
        applicationstrategydetails,
        liquidFeeSlabDetails,
        feeSlabdetails,
        cheque,
        rtgs,
        saveType,
        isSTPApplicable,
        stpApplicableData,
        totalLumpsumInvestmentAmount,
        ...rest
      } = values;

      const selectedApplicationstrategydetails = filterActiveSelectedStratagies(
        isSTPApplicable,
        applicationstrategydetails
      );

      const liquidStrategy = filterActiveLiquidStrategy(selectedApplicationstrategydetails);

      const equityStrategy = filterActiveEquityStrategy(selectedApplicationstrategydetails);

      if (!checkStrategyBoxSelected(selectedApplicationstrategydetails)) {
        throw 'Please select one strategy';
      }

      if (
        !selectedApplicationstrategydetails?.some((str) =>
          containsLiquid(str.strategyName || '')
        ) &&
        isSTPApplicable
      ) {
        throw 'Please select one liquid strategy';
      }
      if (
        !selectedApplicationstrategydetails?.some(
          (str) =>
            containsEquity(str) &&
            (isStpLumpsumDateValid ? !isLumpSumMode(str?.investmentMode || '') : true)
        ) &&
        isSTPApplicable
      ) {
        throw 'Please select one equity strategy';
      }

      if (
        isSTPApplicable &&
        selectedApplicationstrategydetails?.some((str) => {
          if (!containsEquity(str) || isLumpSumMode(str?.investmentMode || '')) {
            return false;
          }
          const allocation = Number(str?.allocation);
          return !allocation || allocation < 1 || allocation > 100;
        })
      ) {
        throw 'Allocation % must be between 1 and 100';
      }

      if (
        isSTPApplicable &&
        (Number(rest.investmentAmount) || 0) + (Number(totalLumpsumInvestmentAmount) || 0) < 5000000
      ) {
        throw 'Total STP Investment Amount and Total Lumpsum Investment Amount together must be greater than or equal to 50 lakhs';
      }

      if (
        liquidStrategy.length > 0 &&
        !checkStrategyFeeTypeSelected(liquidStrategy, application as ApplicationProps)
      ) {
        throw 'Please select one fee type for liquid strategy';
      }
      if (
        equityStrategy.length > 0 &&
        !checkStrategyFeeTypeSelected(equityStrategy, application as ApplicationProps)
      ) {
        throw 'Please select one fee type for equity strategy';
      }

      if (
        equityStrategy?.length > 0 &&
        !checkStrategyFeeSlabSelected(selectedApplicationstrategydetails, feeSlabdetails)
      ) {
        throw 'Please select one fee slab for equity strategy';
      }

      if (
        liquidStrategy?.length > 0 &&
        !isSTPApplicable &&
        !checkStrategyFeeSlabSelected(selectedApplicationstrategydetails, liquidFeeSlabDetails)
      ) {
        throw 'Please select one fee slab for liquid strategy';
      }
      const updatedPayload = {
        ...comparission(values),
        isSTPApplicable: isSTPApplicable,
        totalLumpsumInvestmentAmount: isSTPApplicable ? totalLumpsumInvestmentAmount : null,
      };

      const checkApplication = applicationComparison(
        {
          ...application,
        },
        {
          ...updatedPayload,
          currentStep: !!currentStep && currentStep > 8 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                checkInitialApplicationStatusIsChecker(application) &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: 9,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        !isSaveLater
          ? history.push('disclosure-of-interest', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('disclosure-of-interest', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const handleIsSTPApplicable = (val: string) => {
    const isApplicable = val?.toLowerCase() === 'true';
    setSTPChange({ ...stpChange, open: true, stpApplicableValue: isApplicable });
  };
  const handleCloseStpConfirmationPopup = () => {
    setSTPChange({ ...stpChange, open: false });
  };
  return (
    <>
      <Formik
        initialValues={selectedStrategyData}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validate={(values: Values) => {
          try {
            validateYupSchema(values, StrategyDetailSchema(isStpLumpsumDateValid), true, values);
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, setValues, setFieldValue, values }) => {
          const equityStrategies = values.applicationstrategydetails.filter((val) =>
            containsEquity(val)
          );
          const equityFeeSlabStrategy = equityStrategies[equityStrategies.length - 1];
          const equityFeeSlabIndex = equityStrategies.length;

          return (
            <>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container sx={{ alignItems: 'center', mb: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        color: 'rgba(38, 48, 60, 0.6)',
                        fontSize: 16,
                        fontWeight: 500,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}>
                      Systematic Transfer Plan applicable?
                      <InfoIcon color="info" fontSize="medium" onClick={() => setDialog(true)} />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <UseRadioGroup
                      name={`isSTPApplicable`}
                      items={stpApplicableOptions}
                      value={values.isSTPApplicable?.toString()}
                      disabled={
                        application
                          ? checkValidationBasedOnDate(stpApplicableDate, application.createdAt)
                          : undefined
                      }
                      onChange={(e) => {
                        handleIsSTPApplicable(e.target.value);
                        // setSTPChange(true);
                      }}
                    />
                  </Grid>
                </Grid>
                {values.applicationstrategydetails?.length !== 0 ? (
                  <>
                    {values?.isSTPApplicable ? (
                      <>
                        <LiquidAndEquityStrategyDetails
                          values={values}
                          setValues={setValues}
                          setFieldValue={setFieldValue}
                          newStrategy={{
                            ...newStrategy,
                            trancheAmount: values.stpApplicableData.trancheAmount,
                          }}
                          strategyData={stpStrategyData as Partial<StrategyDetailsType>[]}
                          feeSlabsData={feeSlabsData}
                        />
                        {equityFeeSlabStrategy && (
                          <FeeTypeComponent
                            feeSlabsData={feeSlabsData}
                            strategy={equityFeeSlabStrategy}
                            applicationStrategyIndex={equityFeeSlabIndex}
                            setValues={setValues}
                            values={{
                              ...values,
                              applicationstrategydetails: values.applicationstrategydetails.map(
                                (str) => ({
                                  ...str,
                                  feeType: str.feeType || ('Fixed' as FeeType),
                                })
                              ),
                            }}
                          />
                        )}
                        <Grid container spacing={2} sx={{ alignItems: 'flex-start', mb: 1 }}>
                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                flex: 1,
                                maxWidth: '100%',
                              }}>
                              <MFTextField
                                name={`investmentAmount`}
                                label={`Total ${
                                  values?.isSTPApplicable ? 'STP' : ''
                                }  Investment Amount (in INR) *`}
                                placeholder={`Enter Total ${
                                  values?.isSTPApplicable ? 'STP' : ''
                                }  Investment Amount `}
                                type="number"
                                disabled={true}
                              />
                            </Box>
                            {!!(
                              Number(values.applicationstrategydetails[0]?.investmentAmount) > 0
                            ) && (
                              <Typography sx={{ fontSize: 13, mt: 0.5 }}>
                                {currencyConversion(
                                  values.applicationstrategydetails[0]?.investmentAmount
                                )}
                              </Typography>
                            )}
                          </Grid>
                          {isStpLumpsumDateValid && (
                            <Grid item xs={12} sm={6}>
                              <Box
                                sx={{
                                  flex: 1,
                                  maxWidth: '100%',
                                }}>
                                <MFTextField
                                  name="totalLumpsumInvestmentAmount"
                                  label="Total Lumpsum Investment Amount (in INR)"
                                  placeholder="Enter Total Investment Amount"
                                  type="number"
                                  onKeyDown={(e) => {
                                    allowOnlyNumbers(e);
                                  }}
                                  trimOnBlur={false}
                                  disabled={true}
                                />
                                {values?.totalLumpsumInvestmentAmount && (
                                  <Typography sx={{ fontSize: 13, mt: 0.5 }}>
                                    {currencyConversion(values?.totalLumpsumInvestmentAmount)}
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    ) : (
                      <>
                        {
                          <Box sx={{ mt: 3 }}>
                            {values.applicationstrategydetails?.map((strategy, index) => (
                              <StrategyAccordionAndFeeSlabsTable
                                key={index}
                                values={values}
                                setValues={setValues}
                                strategyMasterData={strategyData}
                                feeSlabsData={feeSlabsData}
                                strategy={strategy}
                                applicationStrategyIndex={index}
                                setSelectedLiquidStrategy={setSelectedLiquidStrategy}
                                setOpenLiquid={setOpenLiquid}
                              />
                            ))}
                          </Box>
                        }
                        {/* <SubHeading sx={{ color: '#131836', fontSize: 18, fontWeight: 500, mt: 0, mb: 3 }}>
                Fund details
              </SubHeading> */}
                        <Box sx={{ mb: 5, maxWidth: 310, '& .MuiFormControl-root': { mb: 0 } }}>
                          <MFTextField
                            name="investmentAmount"
                            label="Total Investment Amount (in INR) *"
                            placeholder="Enter Total Investment Amount"
                            type="number"
                            onKeyDown={(e) => {
                              allowOnlyNumbers(e);
                            }}
                            trimOnBlur={false}
                            disabled={true}
                          />
                          {values.investmentAmount && (
                            <Typography sx={{ fontSize: 13, mt: 0.5 }}>
                              {currencyConversion(values.investmentAmount)}
                            </Typography>
                          )}
                        </Box>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                      <Typography sx={{ fontWeight: 500 }}>
                        {strategyLoader ? (
                          <LinearProgress sx={{ ml: 5, mr: 5 }} />
                        ) : (
                          'No strategies mapped for this distributor'
                        )}
                      </Typography>
                    </Box>
                  </>
                )}

                <ProceedSaveLater
                  saveLater={() => {
                    setValues({
                      ...values,
                      saveType: 'save for later',
                    });
                  }}
                  saveAndProceed={() => {
                    setValues({
                      ...values,
                      saveType: 'save and proceed',
                    });
                  }}
                  loader={loading}
                  clickedButton={values.saveType}
                />
              </Box>
              <InfoDialog
                onClose={() => setDialog(false)}
                open={openDialog}
                content={`STP feature is available for the applications created from ${stpApplicableDate}`}
              />

              <ConfirmationDialog
                message={
                  'For the application only one liquid strategy can be selected, Are you sure you want to proceed with this Strategy ?'
                }
                open={OpenliquidStrategy}
                setOpen={() => setOpenLiquid(false)}
                onSave={async () => {
                  setValues({
                    ...values,
                    liquidFeeSlabDetails: feeSlabsData.filter(
                      (val) => val.feeType === Liquid_FeeType
                    ),
                    applicationstrategydetails: values.applicationstrategydetails.map(
                      (value, index) => {
                        if (selectedLiquidStrategy === index) {
                          return {
                            ...value,
                            isActive: true,
                            feeType: Liquid_FeeType,
                          };
                        } else if (containsLiquid(value.strategyName || '') && value.isActive) {
                          return {
                            ...value,
                            isActive: false,
                          };
                        } else {
                          return value;
                        }
                      }
                    ),
                  });
                  setOpenLiquid(false);
                }}
                onCancel={() => setOpenLiquid(false)}
              />
              <ConfirmationDialog
                message={`Are you sure you want to switch the mode ?`}
                open={stpChange.open}
                setOpen={handleCloseStpConfirmationPopup}
                onSave={() => {
                  const formData = setInitialData(
                    feeSlabsData.map((_updateFeeSlab) => ({
                      ..._updateFeeSlab,
                      id: _updateFeeSlab.feeSlabId,
                    })),
                    initialStrategyResult
                  );
                  const savedStp = stpChange.stpApplicableValue === application?.isSTPApplicable;
                  setValues({
                    ...values,
                    liquidFeeSlabDetails: savedStp
                      ? formData.liquidFeeSlabDetails
                      : values.liquidFeeSlabDetails.map((fee) => {
                          return {
                            ...fee,
                            isActive: false,
                          };
                        }),
                    feeSlabdetails: savedStp
                      ? formData.feeSlabdetails
                      : values.feeSlabdetails.map((_fee) => {
                          return {
                            ..._fee,
                            isActive: false,
                          };
                        }),

                    applicationstrategydetails: stpChange.stpApplicableValue
                      ? formData.applicationstrategydetails.map((strategy) => {
                          return {
                            ...strategy,
                            isActive: savedStp ? strategy.isActive : false,
                          };
                        })
                      : selectedStrategyData.applicationstrategydetails.map((_strategy) => {
                          return {
                            ..._strategy,
                            isActive: savedStp ? _strategy.isActive : false,
                          };
                        }),
                    stpApplicableData: savedStp
                      ? formData.stpApplicableData
                      : initialValues.stpApplicableData,
                    investmentAmount: savedStp ? formData.investmentAmount : null,
                    isSTPApplicable: stpChange.stpApplicableValue,
                  });
                  handleCloseStpConfirmationPopup();
                }}
                onCancel={handleCloseStpConfirmationPopup}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
}
